module.exports = __webpack_public_path__ + "static/media/deniedAccess.bb325624.svg";